import { xAdd, xMinValue } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function setMinX(data, options = {}) {
    const { min = 0 } = options;
    const existingMin = xMinValue(data.x);
    if (existingMin === min) {
        return { data };
    }
    return {
        data: {
            x: xAdd(data.x, min - existingMin),
            y: data.y,
        },
    };
}
//# sourceMappingURL=setMinX.js.map